var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.rerenderKey,staticStyle:{"position":"absolute","cursor":"move"},style:({
    'background-color': (_vm.settings.color ? _vm.settings.color : 'black'),
    top: ((_vm.settings.yPos) + "px"),
    left: ((_vm.settings.xPos) + "px"),
    width: ((_vm.settings.width) + "px"),
    height: ((_vm.settings.height) + "px"),
    'z-index': _vm.isDragging ? 901 : 900,
  }),on:{"mousedown":function($event){$event.stopPropagation();return _vm.onDragMouse($event)},"touchstart":function($event){$event.stopPropagation();return _vm.onDragTouch($event)},"mouseup":_vm.onDropMouse,"touchend":_vm.onDropTouch,"mousemove":_vm.onMoveMouse,"touchmove":_vm.onMoveTouch}},[(_vm.isDragging)?_c('div',{staticStyle:{"position":"absolute","top":"-5000px","left":"-5000px","width":"10000px","height":"10000px"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba5bb65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/ui/DraggableDiv.vue
// module id = null
// module chunks = 